import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { CHECKOUT_URL, HERO_IMAGE, HERO_IMAGE_ALT } from '../data/offer';
import { everythingIncluded } from '../data/everythingIncluded';
import { trackCheckout } from '../utils/tracking';
export function EverythingIncluded() {
  const featured = everythingIncluded.filter(item => item.featured);
  const supporting = everythingIncluded.filter(item => !item.featured);
  return <section className="py-24 px-4 bg-neutral-100" data-id="element-69" data-mp="38n415zsrtsyv">
      <div className="max-w-5xl mx-auto" data-id="element-70" data-mp="3djayj473pw57">
        <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-neutral-900 text-center mb-12 uppercase" data-id="element-71" data-mp="3dm6tqkrke6py">
          Everything Included in <span className="text-red-700" data-id="element-72" data-mp="3mlaeruaakw73">Fire Service Instructor Atlas</span>
        </h2>

        <ul className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4" data-id="element-73" data-mp="xt853nwdqwwe">
          {featured.map(({
          label,
          icon: Icon
        }) => <li key={label} className="bg-neutral-900 border-b-4 border-red-600 rounded-2xl p-5 flex flex-col items-start gap-3" data-id="element-74" data-mp="11tibv2rzxrcb">
              <Icon size={28} className="text-red-400" aria-hidden="true" data-id="element-75" data-mp="1dazfvbsfqlhy" />
              <span className="text-white font-extrabold text-sm md:text-base uppercase leading-snug" data-id="element-76" data-mp="1d8wrsxauf2fv">
                {label}
              </span>
            </li>)}
        </ul>

        <ul className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 mb-20" data-id="element-77" data-mp="14c499ylhb9e4">
          {supporting.map(({
          label,
          icon: Icon
        }) => <li key={label} className="bg-white border border-neutral-200 rounded-xl p-4 flex items-center gap-3" data-id="element-78" data-mp="ujq6d2inzwqd">
              <span className="w-9 h-9 rounded-lg bg-red-50 text-red-700 flex items-center justify-center shrink-0" data-id="element-79" data-mp="pj2fqhyclhwo">
                <Icon size={18} aria-hidden="true" data-id="element-80" data-mp="gkh1gyzwsp1p" />
              </span>
              <span className="text-neutral-900 font-bold text-xs uppercase leading-tight" data-id="element-81" data-mp="gjnp9ii6l7c6">
                {label}
              </span>
            </li>)}
        </ul>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-white border-2 border-red-700 rounded-3xl p-8 md:p-12 shadow-xl shadow-neutral-900/10 text-center" data-id="element-82" data-mp="1wytnrr1veb2">
          <img src={HERO_IMAGE} alt={HERO_IMAGE_ALT} className="w-full max-w-md h-auto mx-auto mb-8" loading="lazy" data-id="element-83" data-mp="3t5w3tryln2mq" />
          <p className="text-2xl md:text-3xl font-extrabold tracking-tight text-neutral-900 mb-1" data-id="element-84" data-mp="pmjc89jak9jt">
            FIRE SERVICE INSTRUCTOR <span className="text-red-700" data-id="element-85" data-mp="fxjcup0vnc53">ATLAS</span>
          </p>
          <p className="text-base font-semibold text-neutral-900 mb-3" data-id="element-86" data-mp="fvyeeobfz91y">
            The Complete Visual Firefighter Training & Reference System
          </p>
          <p className="text-base text-neutral-800/80 max-w-2xl mx-auto mb-8" data-id="element-87" data-mp="18ec3nzippmpf">
            A complete 6-in-1 professional visual training system created to help fire service
            instructors prepare lessons, explain essential concepts, organize firefighter training
            and assess student development with more clarity and confidence.
          </p>
          <p className="text-4xl md:text-5xl font-extrabold tracking-tight text-red-700 mb-6" data-id="element-88" data-mp="31yduv3m7zvo5">
            $27 USD
          </p>
          <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="w-full md:w-auto text-xl py-6 px-12 mb-6" data-id="element-89" data-mp="2a4v8hxtpl1g0">
            GET THE COMPLETE 6-IN-1 FIRE SERVICE INSTRUCTOR ATLAS NOW
          </Button>
          <p className="text-xs text-neutral-800/60 mb-10" data-id="element-90" data-mp="2j3ytj7cfrqx5">
            Immediate Access · 6 Professional Volumes · 5 Bonuses · One-Time Payment
          </p>
          <div className="pt-8 border-t border-neutral-200" data-id="element-91" data-mp="3uk6zzjuznme3">
            <p className="text-2xl md:text-3xl font-bold tracking-tight text-neutral-900 mb-2 uppercase" data-id="element-92" data-mp="3pm5iv4h4hx59">
              Stop Planning Every Firefighter Training Session From Scratch.
            </p>
            <p className="text-lg font-semibold text-red-700" data-id="element-93" data-mp="tq0w12apo8b2">
              OPEN IT. SHOW IT. TEACH IT. TRAIN IT.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}